import share_popup from './util/share_popup';

document.addEventListener('DOMContentLoaded', () => {
  share_popup('.btn-sns');
});